import React from 'react';
import { omitNonReactProps } from '~/services/utils';
import { useTheme } from 'styled-components';
import { IconProps } from '~/types/utils';

const LinkedIn = ({ fill, size = 24, ...otherProps }: IconProps) => {
	const theme = useTheme();
	const secondaryFill = fill !== '#fff' ? 'white' : 'none';
	return (
		<svg
			focusable="false"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={fill ?? theme.colors.icon}
			{...omitNonReactProps(otherProps)}
		>
			<path
				d="M12.7776 10.8638V10.8917H12.7593C12.7621 10.8871 12.7655 10.8821 12.7689 10.8771C12.7719 10.8727 12.7749 10.8682 12.7776 10.8638Z"
				fill={fill ?? theme.colors.icon}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.23853 3C3.55451 3 3 3.55451 3 4.23853V19.7615C3 20.4455 3.55451 21 4.23853 21H19.7615C20.4455 21 21 20.4455 21 19.7615V4.23853C21 3.55451 20.4455 3 19.7615 3H4.23853ZM18.4817 18.2753V13.3236C18.4817 10.6712 17.1108 9.4369 15.2822 9.43694C13.8062 9.43694 13.1468 10.2763 12.7776 10.8638V9.63981H9.99847C10.0359 10.4505 9.99847 18.2753 9.99847 18.2753H12.7779V13.4527C12.7779 13.1943 12.7967 12.9374 12.87 12.7528C13.071 12.2364 13.5279 11.7026 14.2956 11.7026C15.3013 11.7026 15.7032 12.4947 15.7032 13.6553V18.2753H18.4817ZM5.51836 6.9688C5.51836 6.12145 6.14028 5.47709 7.09111 5.47709C8.04202 5.47709 8.62654 6.12145 8.6448 6.9688C8.6448 7.79781 8.04202 8.4616 7.07278 8.4616H7.05422C6.12229 8.4616 5.51836 7.79769 5.51836 6.9688ZM8.46177 18.2753H5.68343V9.63981H8.46177V18.2753Z"
				fill={fill}
			/>
			<path
				d="M5.68343 18.2753H8.46177V9.63981H5.68343V18.2753Z"
				fill={secondaryFill}
			/>
			<path
				d="M7.09111 5.47709C6.14028 5.47709 5.51836 6.12145 5.51836 6.9688C5.51836 7.79769 6.12229 8.4616 7.05422 8.4616H7.07278C8.04202 8.4616 8.6448 7.79781 8.6448 6.9688C8.62654 6.12145 8.04202 5.47709 7.09111 5.47709Z"
				fill={secondaryFill}
			/>
			<path
				d="M18.4818 13.3235V18.2752H15.7033V13.6552C15.7033 12.4946 15.3014 11.7025 14.2957 11.7025C13.528 11.7025 13.0711 12.2363 12.8701 12.7527C12.7968 12.9373 12.778 13.1942 12.778 13.4526V18.2752H9.99854C9.99854 18.2752 10.036 10.4504 9.99854 9.63976H12.7777V10.8637C13.1469 10.2762 13.8063 9.43689 15.2823 9.43689C17.1109 9.43685 18.4818 10.6711 18.4818 13.3235Z"
				fill={secondaryFill}
			/>
		</svg>
	);
};

export default LinkedIn;
